var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ai-camera-list',{attrs:{"devicemoduletype":"2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }